import { UploadedGuestData, UploadedStructureData } from '@features/add-participants-modal/with-excel';
import { getJWTTokens } from '@shared/libs/local-storage';
import { buildPrivateApiPath } from '@shared/api/api-url';

export const upload = async (file: File, url: string) => {
  const { accessToken } = getJWTTokens();

  const formData = new FormData();
  formData.append('file', file);

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: 'application/json',
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error('Не удалось загрузить файл');
  }

  return response.json();
};

// Импорт сотрудников орг. структура
export const uploadStructureFile = async (file: File): Promise<UploadedStructureData> => {
  const url = buildPrivateApiPath('/api/v1/xlsx');
  return upload(file, url);
};

// Импорт внештатных участников
export const uploadGuestFile = async (file: File): Promise<UploadedGuestData> => {
  const url = buildPrivateApiPath('/api/v1/xlsx/guest');
  return upload(file, url);
};
